module.exports = __webpack_public_path__ + "static/media/banner.65a0463.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner.mp4
// module id = 3C4B
// module chunks = 3